"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Constraint2 = _interopRequireDefault(require("../Constraint"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _newArrowCheck(innerThis, boundThis) { if (innerThis !== boundThis) { throw new TypeError("Cannot instantiate an arrow function"); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @class constraints/Basic/Type
 */
var Type =
/*#__PURE__*/
function (_Constraint) {
  _inherits(Type, _Constraint);

  /**
   * @type {String}
   */

  /**
   * Constructor.
   *
   * @param {String} reference
   * @param {String} errorMessage
   */
  function Type(reference) {
    var _this;

    var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _classCallCheck(this, Type);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Type).call(this));
    Object.defineProperty(_assertThisInitialized(_this), "reference", {
      enumerable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "setReference", {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        _newArrowCheck(this, this);

        _this.reference = _value;
        return _assertThisInitialized(_this);
      }.bind(this)
    });
    Object.defineProperty(_assertThisInitialized(_this), "isValid", {
      enumerable: true,
      writable: true,
      value: function value() {
        _newArrowCheck(this, this);

        var isValid = false;

        if (_this.value && _this.reference === 'array') {
          isValid = _this.value.constructor.name === 'Array';
        } else {
          isValid = _typeof(_this.value) === _this.reference;
        }

        return isValid;
      }.bind(this)
    });

    if (reference) {
      _this.setReference(reference);
    }

    _this.message = 'This value must be a type of ' + _this.reference;

    if (errorMessage !== '') {
      _this.message = errorMessage;
    }

    return _this;
  }
  /**
   * Sets the value as reference for validation.
   *
   * @param {String} value
   *
   * @returns {Object}
   */


  return Type;
}(_Constraint2.default);

var _default = Type;
exports.default = _default;